<template>
    <div id="app">
        <a-layout style="min-width: 1366px">
            <a-layout-header>
                <div style="height: 100px">
                    <div class="FL">
                        <img src="../static/images/u101.png" alt="" class="top-logo">
                    </div>
                    <div class="FL line"></div>
                    <div class="FL">
                        <p class="header-title font-weight">{{ $t('lang.name') }}</p>
                        <p class="header-title2 font-weight">{{ $t('lang.Customized') }}</p>
                    </div>
                    <div class="FR">
                        <p class="phone-title">{{ $t('lang.hotline') }}：</p>
                        <p class="phone-title2">151 6566 2714</p>
                    </div>
                    <div class="FR">
                        <img src="../static/images/u108.png" alt="" class="phone-img">
                    </div>
                    <div class="FR">
                        <div class="lang" v-if="locale==='en'" @click="changeLang('zh')">
                            <img src="../static/images/img1.png" alt="" style="width: 30px">
                            简体中文
                        </div>
                        <div class="lang" v-if="locale==='zh'" @click="changeLang('en')">
                            <img src="../static/images/img2.png" alt="" style="width: 30px">
                            English
                        </div>
                        <!--                        <a-radio-group v-model="locale" @change="changeLang()">-->
                        <!--                            <a-radio-button value="zh">-->
                        <!--                                中文-->
                        <!--                            </a-radio-button>-->
                        <!--                            <a-radio-button value="en">-->
                        <!--                                英文-->
                        <!--                            </a-radio-button>-->
                        <!--                        </a-radio-group>-->
                    </div>
                    <div class="ClearFloat"></div>
                </div>
                <div style="width: 100%;background: #ffb700">
                    <div class="box_fixed" id="boxFixed" :class="{'is_fixed' : isFixed}">
                        <a-row type="flex" class="nav text-align cursor-pointer" justify="center">
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(1)" v-bind:class="{ SelectNav: SelectNav===1,navHover:true }">
                                    {{ $t('lang.index') }}
                                </div>
                            </a-col>
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(2)" v-bind:class="{ SelectNav: SelectNav===2,navHover:true }">
                                    {{ $t('lang.Introduction') }}
                                </div>
                            </a-col>
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(3)" v-bind:class="{ SelectNav: SelectNav===3,navHover:true }">
                                    {{ $t('lang.Product') }}
                                </div>
                            </a-col>
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(4)" v-bind:class="{ SelectNav: SelectNav===4,navHover:true }">
                                    {{ $t('lang.news') }}
                                </div>
                            </a-col>
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(5)" v-bind:class="{ SelectNav: SelectNav===5,navHover:true }">
                                    {{ $t('lang.Qualification') }}
                                </div>
                            </a-col>
                            <a-col style="width: 160px" class="padding20">
                                <div v-on:click="clickNav(6)" v-bind:class="{ SelectNav: SelectNav===6,navHover:true }">
                                    {{ $t('lang.contact') }}
                                </div>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </a-layout-header>
            <a-layout-content>
                <router-view/>
            </a-layout-content>
            <a-layout-footer class="MT30">
                <div class="FL">
                    <p class="footer-t1 font-weight">贝威科技(潍坊)有限公司</p>
                    <p class="footer-t2 font-weight">Baway Technology（Weifang）Co.,Ltd.</p>
                </div>
                <div class="FL line"></div>
                <div class="FL">
                    <p class="footer-title mt-10">{{ $t('lang.add') }}：{{ $t('lang.addInfo') }}</p>
                    <p class="footer-title">{{ $t('lang.Website') }}：www.bawayft.com</p>
                    <p class="footer-title">{{ $t('lang.Email') }}：office@bawaytech.com</p>
                    <a class="footer-title" href="https://beian.miit.gov.cn/" rel="nofollows"
                       target="_blank">ICP证：鲁ICP备20031259号-1</a>
                </div>

                <div class="FRR">
                    <p class="phone-title">{{ $t('lang.hotline') }}：</p>
                    <p class="phone-title2">151 6566 2714</p>
                </div>
                <div class="FR">
                    <img src="../static/images/u108.png" alt="" class="phone-img">
                </div>
               <!-- <div class="FR" style="margin-right: 20px;width: 300px;color: white;margin-top: 10px">
                    <div class="FL">
                        友情链接：
                    </div>
                    <div v-for="(item,i) in links" :key="i" class="FL">
                        <a class="footer-title" :href="item.url" rel="nofollows" target="_blank">{{ item.name }}</a>
                    </div>
                    <div class="ClearFloat"></div>
                </div>-->
                <div class="ClearFloat"></div>
            </a-layout-footer>
        </a-layout>
    </div>
</template>

<script>

import {get} from "@/utils";

export default {
    name: 'App',
    data() {
        return {
            isFixed: false,
            offsetTop: 0,
            SelectNav: 1,
            locale: 'zh',
            links: [],
        }
    },
    mounted() {
        this.locale = localStorage.getItem("lang") || 'zh';
        window.addEventListener('scroll', this.initHeight);
        this.$nextTick(() => {
            this.offsetTop = document.querySelector('#boxFixed').offsetTop;
        })
        this.nav(this.$route.name);
        get('/links/getLinksList', {}).then(res => {
            this.links = res.data.list;
        }).catch(() => {
        })
    },
    watch: {
        $route(to) {
            this.nav(to.name);
        }
    },
    methods: {
        changeLang(locale) {
            localStorage.setItem("lang", locale);
            this.$i18n.locale = locale;
            this.$router.go(0)
        },
        nav(n) {
            switch (n) {
                case 'Home':
                    this.SelectNav = 1;
                    break;
                case 'Introduction':
                    this.SelectNav = 2;
                    break;
                case 'Goods':
                    this.SelectNav = 3;
                    break;
                case 'GoodInfo':
                    this.SelectNav = 3;
                    break;
                case 'News':
                    this.SelectNav = 4;
                    break;
                case 'NewInfo':
                    this.SelectNav = 4;
                    break;
                case 'Qualification':
                    this.SelectNav = 5;
                    break;
                case 'QualificationInfo':
                    this.SelectNav = 5;
                    break;
                case 'About':
                    this.SelectNav = 6;
                    break;
            }
        },
        initHeight() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.isFixed = scrollTop > this.offsetTop;
        },
        clickNav(i) {
            this.SelectNav = i;
            switch (i) {
                case 1:
                    this.$router.push({path: '/'});
                    break;
                case 2:
                    this.$router.push({path: '/introduction.html'});
                    break;
                case 3:
                    this.$router.push({path: '/goods/' + 0 + '.html'})
                    break;
                case 4:
                    this.$router.push({path: '/news.html'});
                    break;
                case 5:
                    this.$router.push({path: '/qualification.html'});
                    break;
                case 6:
                    this.$router.push({path: '/about.html'});
                    break;
            }
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
}
</script>

<style>
.FRR {
    float:right;
    padding-right: 330px;

}
.lang {
    height: 30px;
    margin-right: 20px;
    margin-top: 38px;
    cursor: pointer;
    font-size: 18px;
}

.ant-layout {
    background: white !important;
}

.SelectNav {
    color: #F77C03 !important;
    border-top: 2px solid #F77C03 !important;
    border-bottom: 2px solid #F77C03 !important;
}

.navHover:hover {
    color: #F77C03 !important;
    border-top: 2px solid #F77C03 !important;
    border-bottom: 2px solid #F77C03 !important;
}

.padding20 {
    padding: 1px 20px;
}

#app {
    background-color: #ffffff;
}

.top-logo {
    width: 200px;
    margin-left: 20px;
    margin-top: 25px;
}

.ant-layout-header {
    height: 145px !important;
    padding: 0 !important;
    background: white !important;
    line-height: normal !important;
}

.ant-layout-content {
    padding: 0 !important;
}

.line {
    height: 60px;
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 15px;
    border: 2px solid #8c939d;
}

.header-title {
    font-size: 30px;
    color: black;
    margin-top: 18px;
}

.header-title2 {
    font-size: 16px;
    color: #07569F;
    margin-top: 2px;
}

.phone-img {
    width: 60px;
    margin-top: 20px;
    margin-right: 5px;
}

.phone-title {
    margin-top: 20px;
    font-size: 18px;
    letter-spacing: 2px;
}

.phone-title2 {
    font-size: 24px;
    margin-top: 2px;
    letter-spacing: 2px;
    font-weight: bold;
    margin-right: 30px;
}

.box_fixed {
    height: 45px;
    width: 100%;
    background: #309494;
}

.is_fixed {
    position: fixed;
    top: 0;
    z-index: 999;
}

.nav {
    line-height: 40px;
    color: white;
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 16px;
}

.ant-layout-footer {
    background: #4FA0A0 !important;
    height: 100px !important;
    padding: 0 !important;
}

.footer-t1 {
    font-size: 36px;
    margin-left: 40px;
    margin-top: 15px;
    color: white;
    margin-right: 20px;
}

.footer-t2 {
    color: white;
    font-size: 18px;
    margin-left: 40px;
}

.mt-15 {
    margin-top: 15px;
}

.mt-10 {
    margin-top: 10px;
}

.footer-title {
    color: white;
    line-height: 20px;
    margin-left: 20px;
}
</style>
